import React, { ChangeEvent } from 'react';
import { Grid, TextInput } from '@ts/storybook';
import { IOrganization } from '@ts/ui-models';

interface MainInformationStepOneProps {
  formData: IOrganization;
  setFormData: (attr: string) => (event: ChangeEvent | null, value: string | number | null) => void;
  requiredFields: string[];
  isPreview?: boolean;
}

const MainInformationStepOne: React.FC<MainInformationStepOneProps> = props => {
  const focus = props.requiredFields[0] ?? 'name';

  return (
    <Grid container spacing={2} p={2}>
      <Grid size={{ xs: 12 }}>
        <TextInput
          label="Name"
          focus={focus === 'name'}
          value={props.formData.name}
          required={props.requiredFields.includes('name')}
          onChange={props.setFormData('name')}
          isReadOnly={props.isPreview}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <TextInput
          label="ID"
          type="ID"
          focus={focus === 'logicalId'}
          value={props.formData.logicalId}
          required={props.requiredFields.includes('logicalId')}
          onChange={props.setFormData('logicalId')}
          isReadOnly={props.isPreview}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <TextInput
          label="Acronym"
          focus={focus === 'acronym'}
          value={props.formData.acronym}
          required={props.requiredFields.includes('acronym')}
          onChange={props.setFormData('acronym')}
          isReadOnly={props.isPreview}
        />
      </Grid>
    </Grid>
  );
};
export default MainInformationStepOne;
